export default __webpack_public_path__ + "static/media/pinkgem.c2cc2a4b.jpg";